let language = {
    "LBL_ADMIN":"Admin",
    "LBL_ADD_EMAILS":"ADD Emails",
    "LBL_VIEW_EMAILS":"View Emails",
    "LBL_EMAIL_OPTIONS":"Email Notification Options",
    "LBL_FROM_NAME":"'From' Name",
    "LBL_FROM_ADDRESS":"'From' Address",
    "LBL_MAIL_TRANSFER":"Mail Transfer Agent",
    "LBL_SMTP_SERVE":"SMTP Serve",
    "LBL_SMTP_PORT":"SMTP Port",
    "LBL_SMTP_AUTH":"Use SMTP Authentication?",
    "LBL_ENABLE_SMTP":"Enable SMTP over SSL",
    "LBL_SMTP_USERNAME":"SMTP Username",
    "LBL_SMTP_PASSWORD":"SMTP Password",
    "LBL_SEARCH":"Search",
    "LBL_DATE_CREATED":"Date Created",
    "LBL_EMAIL_STATUS":"Email Status",
    "LBL_SUBJECT":"Subject",
    "LBL_EMAIL_LIST":"Email List",
    "LBL_SEND_EMAILS":"Sent Email",
    "LBL_ASSIGNED_TO":"Assigned to",
    "LBL_DATE_SEND":"Date Sent",
    "LBL_FROM_EMAIL":"From",
    "LBL_TO_EMAIL":"To",
    "LBL_CC_EMAIL":"Cc",
    "LBL_BCC_EMAIL":"Bcc",
    "LBL_EMAIL_SUBJECT":"Subject",
    "LBL_EMAIL_BODY":"Body",
    "LBL_EMAIL_ATTACHMENTS":"Attachments",
    "":"Settings",
    "":"Settings",
    "LBL_INCOMMING_EMAIL":"Incomming Email Setup",
    "LBL_IMAP_SERVER":"IMAP Server",
    "LBL_IMAP_PORT":"IMAP Port",
    "LBL_IMAP_USER":"IMAP User",
    "LBL_IMAP_PASSWORD":"IMAP Password",
    "LBL_IMAP_ENCRYPTION":"IMAP Encryption",
    "LBL_NEW_MESSAGE":"New Message",
    "LBL_TO_ADDRESS":"To",
    "LBL_CC_ADDRESS":"Cc",
    "LBL_MAIL_SUBJECT":"Subject",
    "LBL_MAIL_ATTACHMENT":"Attachment",
}

export default language;